// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__1X1c0","contact":"Main_contact__33zEn","main__container":"Main_main__container__2HHcB","main__container--type-1":"Main_main__container--type-1__2wPPl"};